import { io } from "socket.io-client";
import { SOCKET_URL } from "../config/apiConfig";

const SERVER_URL = SOCKET_URL;

class AdminSocketService {
  socket;

  connect() {
    if (this.socket && this.socket.connected) {
      console.log("Admin socket already connected.");
      return;
    }

    this.socket = io(SERVER_URL, {
      reconnection: true,
      reconnectionAttempts: 5,
    });

    this.socket.on("connect", () => {
      console.log(
        "Admin successfully connected to /admin-chat with ID:",
        this.socket.id
      );
    });

    this.socket.on("disconnect", () => {
      console.log("Admin disconnected from /admin-chat");
    });

    this.socket.on("connect_error", (err) => {
      console.error("Admin socket connection error:", err.message);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }

  getConversations(callback) {
    if (!this.socket) return;
    this.socket.emit("getAdminConversations", callback);
  }

  getHistoryForUser(payload, callback) {
    if (!this.socket) return;
    this.socket.emit("getHistoryForUser", payload, callback);
  }

  sendMessage(payload, callback) {
    if (!this.socket) return;
    this.socket.emit("adminSendMessage", payload, callback);
  }

  markMessagesAsRead(payload) {
    if (!this.socket) return;
    this.socket.emit("markMessagesAsRead", payload);
  }

  sendTypingStatus(payload) {
    if (!this.socket) return;
    this.socket.emit("typing", payload);
  }

  onNewMessage(callback) {
    if (!this.socket) return;
    this.socket.off("newMessage");
    this.socket.on("newMessage", callback);
  }

  onAdminTyping(callback) {
    if (!this.socket) return;
    this.socket.off("adminTyping");
    this.socket.on("adminTyping", callback);
  }
}

export const adminSocketService = new AdminSocketService();
